import styled, { createGlobalStyle } from 'styled-components';

export const SpectrogramContainer = styled.div`
    display: flex;
    width: 100%;
    min-height: 48px;
    padding: 0.5rem;
    background-color: #f5f5f5;
    border-radius: 0.5rem;
    margin-bottom: -0.5rem;
`;

export const WaveformGlobalStyle = createGlobalStyle`
    #dictate-wave ::part(cursor) {
        border-radius: 0;
    }
`;

export const Wave = styled.div`
    flex: 1;
    width: 100%;
`;
